import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import {
  LaunchNavigator,
  LaunchNavigatorOptions,
} from '@ionic-native/launch-navigator/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import {
  AlertController,
  LoadingController,
  MenuController,
} from '@ionic/angular';
import { take } from 'rxjs/operators';
import { CallUser } from 'src/app/models/Call-User/Call-User';
import { DriverProfileService } from 'src/app/services/driver-profile/driver-profile.service';
import { LoginService } from 'src/app/services/login/login.service';
import { OrderService } from 'src/app/services/order/order.service';
import { environment } from 'src/environments/environment';

interface Coords {
  coords: {
    lat: number;
    lng: number;
  };
}
@Component({
  selector: 'app-driver-pickup',
  templateUrl: './driver-pickup.page.html',
  styleUrls: ['./driver-pickup.page.scss'],
})
export class DriverPickupPage implements OnInit {
  driverID;
  invoice;
  docID;
  currentOrder;

  loading;

  acceptBtnClicked = false;
  rejectBtnClicked = false;

  private mapKey = environment.mapKey;

  constructor(
    private menu: MenuController,
    private router: Router,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private auth: AngularFireAuth,
    private location: Location,
    private locationAccuracy: LocationAccuracy,
    private geolocation: Geolocation,
    private launchNavigator: LaunchNavigator,
    private alertController: AlertController,
    private loginService: LoginService,
    private loadingController: LoadingController,
    private httpClient: HttpClient,
    private driverService: DriverProfileService,
    private barcodeScanner: BarcodeScanner
  ) {}

  ngOnInit() {
    this.auth.authState.pipe(take(1)).subscribe((user) => {
      if (user) {
        this.driverID = user.uid;
        this.route.queryParams.pipe(take(1)).subscribe((res) => {
          this.invoice = Number(res.invoiceNo);
          this.getOrder(this.invoice);
        });
      } else {
        this.router.navigate(['/home/login'], {
          queryParams: { from: this.router.url },
        });
      }
    });
  }

  getOrder(invoice) {
    this.orderService
      .getOrderByInvoice(invoice)
      .pipe(take(1))
      .subscribe((res) => {
        if (res.size > 0) {
          this.docID = res.docs[0].id;
          this.currentOrder = res.docs[0].data();
        } else {
          alert('Something went wrong');
          this.location.back();
        }
      });
  }

  accept() {
    this.acceptBtnClicked = true;
    this.orderService
      .driverAcceptRequest(this.docID, this.driverID, this.currentOrder)
      .then(() => {
        this.acceptBtnClicked = false;
        this.getOrder(this.invoice);
      })
      .catch((e) => {
        alert(JSON.stringify(e));
        this.acceptBtnClicked = false;
      });
  }

  reject() {
    this.rejectBtnClicked = true;
    this.orderService
      .driverRejectRequest(this.docID, this.driverID, this.currentOrder)
      .then(() => {
        this.rejectBtnClicked = false;
        this.getOrder(this.invoice);
      })
      .catch((e) => {
        alert(JSON.stringify(e));
        this.acceptBtnClicked = false;
      });
  }

  goToPoint(type, detailsObj) {
    if (detailsObj.orderType === 'call-order') {
      let obj = {};
      if (type === 'deliver') {
        obj = {
          dropOffCoords: detailsObj.dropOffCoords,
          dropPointAddress: detailsObj.destination,
        };
      }

      if (type === 'pick-up') {
        obj = {
          pickUpAddress: detailsObj.store,
          pointName: detailsObj.store,
          startCoords: detailsObj.pickUpCoords,
        };
      }

      // console.log('call');
      this.presentAlert(type, obj);
    } else {
      // console.log('app');
      this.presentAlert(type, detailsObj);
    }

    // console.log(detailsObj);

    // if (type === 'pick-up') {
    //   this.pickUp(type, detailsObj);
    // }

    // if (type === 'deliver') {
    //   this.deliver(type, detailsObj);
    // }
  }

  pickUp(type, detailsObj, mapType) {
    if (detailsObj.startCoords) {
      const { pickUpAddress, pointName, startCoords } = detailsObj;
      this.presentAlertConfirm(
        type,
        pickUpAddress,
        pointName,
        startCoords,
        mapType
      );
    } else if (detailsObj.docID) {
      this.presentLoading();
      const { docID } = detailsObj;
      this.orderService
        .getStoreCoords(docID)
        .pipe(take(1))
        .subscribe((res) => {
          console.log(res);
          this.dismissLoading();
          if (res.payload.exists) {
            const { pickUpAddress, pointName } = detailsObj;
            const data = res.payload.data() as Coords;
            this.presentAlertConfirm(
              type,
              pickUpAddress,
              pointName,
              data.coords,
              mapType
            );
          } else {
            const { pickUpAddress, pointName } = detailsObj;
            this.presentAlertConfirm(
              type,
              pickUpAddress,
              pointName,
              undefined,
              mapType
            );
          }
        });
    } else {
      const { pickUpAddress, pointName } = detailsObj;
      this.presentAlertConfirm(
        type,
        pickUpAddress,
        pointName,
        undefined,
        mapType
      );
    }
  }

  deliver(type, detailsObj, mapType) {
    console.log(detailsObj);
    console.log(detailsObj.dropOffCoords);
    if (detailsObj.dropOffCoords) {
      const { dropOffCoords, dropPointAddress } = detailsObj;
      this.presentAlertConfirm(
        type,
        dropPointAddress,
        undefined,
        dropOffCoords,
        mapType
      );
    } else {
      const { dropPointAddress } = detailsObj;
      this.presentAlertConfirm(
        type,
        dropPointAddress,
        undefined,
        undefined,
        mapType
      );
    }
  }

  async confirmDelivery() {
    const alert = await this.alertController.create({
      header: 'Confirm Delivery',
      message: 'Are you done delivering the package ?',
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.completeOrder();
          },
        },
      ],
    });

    await alert.present();
  }

  async presentAlert(type, detailsObj) {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Navigate',
      message: 'Select Your Installed App to navigate',
      buttons: [
        {
          text: 'Google Maps',
          handler: () => {
            if (type === 'pick-up') {
              this.pickUp(type, detailsObj, 'google-maps');
            }

            if (type === 'deliver') {
              this.deliver(type, detailsObj, 'google-maps');
            }
          },
        },
        {
          text: 'Waze',
          handler: () => {
            if (type === 'pick-up') {
              this.pickUp(type, detailsObj, 'waze');
            }

            if (type === 'deliver') {
              this.deliver(type, detailsObj, 'waze');
            }
          },
        },
        {
          text: 'Here WeGo',
          handler: () => {
            if (type === 'pick-up') {
              this.pickUp(type, detailsObj, 'here-we-go');
            }

            if (type === 'deliver') {
              this.deliver(type, detailsObj, 'here-we-go');
            }
          },
        },
        // {
        //   text: 'Petal Maps',
        //   handler: () => {
        //     if (type === 'pick-up') {
        //       this.pickUp(type, detailsObj, 'petal-maps');
        //     }

        //     if (type === 'deliver') {
        //       this.deliver(type, detailsObj, 'petal-maps');
        //     }
        //   },
        // },
        {
          text: 'Cancel',
          handler: () => {},
        },
      ],
    });

    await alert.present();
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      message: 'loading...',
    });
    await this.loading.present();
  }

  async dismissLoading() {
    this.loading.dismiss();
  }

  async presentAlertConfirm(type, address, pointName, coords, mapType) {
    let msg = `
      Start navigating to: <br>
      <ion-icon name="location-outline"></ion-icon>
      <b>${address}</b> .<br>
    `;

    if (type === 'pick-up') {
      msg += `
      <span>
        <ion-icon name="storefront-outline"></ion-icon>
        <b>${pointName}</b>
      </span>
      `;
    }

    const alert = await this.alertController.create({
      header: type.toUpperCase(),
      message: msg,
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            const label = pointName !== undefined ? pointName : address;
            console.log(label);
            if (coords) {
              const { lat, lng } = coords;
              if (mapType === 'google-maps') {
                // https: window.location.href =
                //   'geo:-25.48115,28.02004?q=' +
                //   lat +
                //   ', ' +
                //   lng +
                //   '(' +
                //   label +
                //   ')';
                window.location.href =
                  'https://maps.google.com/?q=' +
                  lat +
                  ',' +
                  lng +
                  '(' +
                  label +
                  ')';
              }

              if (mapType === 'waze') {
                window.location.href =
                  'https://www.waze.com/ul?ll=' +
                  lat +
                  ',' +
                  lng +
                  '&navigate=yes&zoom=17&' +
                  '(' +
                  label +
                  ')';
              }

              if (mapType === 'here-we-go') {
                window.location.href =
                  'https://share.here.com/r/' + lat + ',' + lng;
              }

              if (mapType === 'petal-maps') {
                window.location.href =
                  'https://www.petalmaps.com/navigate/?daddr=' +
                  lat +
                  ',' +
                  lng +
                  '&type=drive&utm_source=fb';
              }
            } else {
              // window.location.href = 'geo:-25.48115,28.02004?q=' + address;
              if (mapType === 'google-maps') {
                // window.location.href =
                //   'geo:-25.48115,28.02004?q=' + address + '(' + label + ')';
                window.location.href =
                  'https://maps.google.com/?q=' + address + '(' + label + ')';
              }

              if (mapType === 'waze') {
                window.location.href =
                  'https://www.waze.com/ul?q=' +
                  address +
                  '&navigate=yes&zoom=17';
              }

              if (mapType === 'here-we-go') {
                // window.location.href =
                //   'https://share.here.com/r/' +
                //   lat +
                //   ',' +
                //   lng ;
                this.locateAddressHereWeGo(address);
              }

              if (mapType === 'petal-maps') {
                window.location.href =
                  'https://www.petalmaps.com/navigate/?daddr=' +
                  address +
                  '&type=drive&utm_source=fb';
              }
            }
          },
        },
      ],
    });

    await alert.present();
  }

  locateAddressHereWeGo(address) {
    const coords = '-25.48115,28.02004';
    const countryCode = 'ZAF';
    const url =
      'https://discover.search.hereapi.com/v1/discover?apiKey=' +
      this.mapKey +
      '&at=' +
      coords +
      '&in=countryCode:' +
      countryCode +
      '&q=' +
      address;

    this.httpClient
      .get(url)
      .pipe(take(1))
      .subscribe((data: any) => {
        const addresses = data.items;
        const { lat, lng } = addresses[0].position;

        window.location.href = 'https://share.here.com/r/' + lat + ',' + lng;
      });
  }

  back() {
    this.router.navigate(['driver-request']);
  }
  drop() {
    this.router.navigate(['driver-drop-off']);
  }
  openDriver(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  userProfile() {
    this.router.navigate(['driver-home']);
  }
  request() {
    this.router.navigate(['driver-request']);
  }
  history() {
    this.router.navigate(['driver-history']);
  }
  edit() {
    this.router.navigate(['driver-edit']);
  }
  logout() {
    this.loginService.logout();
  }

  scanQR(order) {
    this.barcodeScanner
      .scan()
      .then((barcodeData) => {
        if (!barcodeData.cancelled && barcodeData.text) {
          const phoneNo = barcodeData.text;
          this.thumaPay(order, phoneNo);
        } else {
          alert('Scanning Cancelled!');
        }
      })
      .catch((err) => {
        alert(err);
      });
  }

  thumaPay(order, phoneNo) {
    const { deliveryFee } = order;

    this.driverService
      .getCallerWallet(phoneNo)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res.empty) {
          const data = res.docs[0].data() as CallUser;
          const phone = data.customerCellphone;
          const name = data.customerName;
          const wallet = data.wallet;
          const walletDocID = res.docs[0].id;

          if (deliveryFee > wallet) {
            alert(
              `Insufficient Funds! (wallet = R${wallet}, Delivery Fee = ${deliveryFee})`
            );
          } else {
            this.confirmUser(
              name,
              phone,
              wallet,
              deliveryFee,
              walletDocID,
              this.docID
            );
          }
        } else {
          alert('No Card Available!');
        }
      });
  }

  async confirmUser(
    name: string,
    phone: string,
    walletValue: number,
    deliveryFee: number,
    walletDocID: string,
    orderDocID: string
  ) {
    const body = `Is this ${name}, ${phone}`;
    const alert = await this.alertController.create({
      header: 'Confirm User',
      message: body,
      buttons: [
        {
          text: 'No',
          handler: () => {},
        },
        {
          text: 'Yes',
          handler: () => {
            this.presentLoading();
            const newValue = walletValue - deliveryFee;
            this.driverService
              .updateCallerWallet(walletDocID, phone, newValue, orderDocID)
              .then(() => {
                this.dismissLoading();
                this.completeOrder();
              });
          },
        },
      ],
    });

    await alert.present();
  }

  checkBalance() {
    this.barcodeScanner
      .scan()
      .then((barcodeData) => {
        if (!barcodeData.cancelled && barcodeData.text) {
          const phoneNo = barcodeData.text;
          this.driverService
            .getCallerWallet(phoneNo)
            .pipe(take(1))
            .subscribe((res) => {
              if (!res.empty) {
                const data = res.docs[0].data() as CallUser;
                const phone = data.customerCellphone;
                const name = data.customerName;
                const wallet = data.wallet;
                this.displayBalance(name, phone, wallet);
              } else {
                alert('No Card Available!');
              }
            });
        } else {
          alert('Scanning Cancelled!');
        }
      })
      .catch((err) => {
        alert(err);
      });
  }

  async displayBalance(name: string, phone: string, balance: number) {
    const output = `${name} (${phone}), balance: R${balance}`;
    const alert = await this.alertController.create({
      header: 'Balance',
      message: output,
      buttons: [
        {
          text: 'Ok',
        },
      ],
    });

    await alert.present();
  }

  completeOrder() {
    this.orderService.completeDelOrder(this.docID).then(() => {
      const { assignedDriver } = this.currentOrder;
      this.driverService.driverOffDelivery(assignedDriver);
      this.router.navigate(['/driver-history']);
    });
  }
}
